<template>
    <v-autocomplete
        outlined
        clearable
        :items="items"
        :loading="isLoading"
        label="Job Number"
        placeholder="Search Jobs"
        item-text="job_number"
        item-value="job_number"
        prepend-inner-icon="mdi-briefcase-search"
        v-bind:value="value"
        v-on="inputListeners"
        return-object
    >
        <template v-slot:selection="data">
            <v-list-item-content>
                <v-list-item-title>
                    {{ data.item.job_number }}
                </v-list-item-title>
            </v-list-item-content>
        </template>
        <template v-slot:item="data">
            <v-list-item-content>
                <v-list-item-title>
                    {{ data.item.job_number }}
                </v-list-item-title>
                <v-list-item-subtitle style="font-size:12px;">
                    <i>{{ data.item.jcco }}</i> -
                    {{ data.item.description }}
                </v-list-item-subtitle>
            </v-list-item-content>
        </template>
    </v-autocomplete>
</template>
<script>
export default {
    name: "OpenJobsAutocomplete",
    inheritAttrs: false,
    computed: {
        inputListeners: function () {
            let vm = this;
            return Object.assign({},
                this.$listeners,
                {
                    input: function (val) {
                        vm.$emit('input', val);
                    }
                }
            )
        }
    },
    data() {
        return {
            items: [],
            isLoading: false,
        }
    },
    created() {
        this.isLoading = true;
        this.getItems();
    },
    methods: {
        async getItems() {
            try {
                const response = await this.axios.get('/ryvit/jobs/open');

                if (response && response.data) {
                    this.items = response.data;
                    this.$emit('update:openJobs', this.items);
                }
            } catch (error) {

            } finally {
                this.isLoading = false;
            }
        }
    },
    props: ['value']
}
</script>